import { render, staticRenderFns } from "./GroupTagging.vue?vue&type=template&id=98d64312&scoped=true"
import script from "./GroupTagging.vue?vue&type=script&lang=js"
export * from "./GroupTagging.vue?vue&type=script&lang=js"
import style0 from "./GroupTagging.vue?vue&type=style&index=0&id=98d64312&prod&scoped=true&lang=css"
import style1 from "./GroupTagging.vue?vue&type=style&index=1&id=98d64312&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d64312",
  null
  
)

export default component.exports